import { render, staticRenderFns } from "./coursewareOrderdteails.vue?vue&type=template&id=69bc942f&scoped=true&"
import script from "./coursewareOrderdteails.vue?vue&type=script&lang=js&"
export * from "./coursewareOrderdteails.vue?vue&type=script&lang=js&"
import style0 from "./coursewareOrderdteails.vue?vue&type=style&index=0&id=69bc942f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc942f",
  null
  
)

export default component.exports